// ----------------------------------------------
// Enum custom formatters registry
// ----------------------------------------------
type EnumFormatter<T> = (value?: T) => string
const formatters = new Map<object, EnumFormatter<any>>()

// Register a custom enum formatter
export function register<T>(
  enumObj: object,
  formatter: EnumFormatter<T>
): void {
  formatters.set(enumObj as object, formatter)
}

// Replace snake case with split words, uppercasing the first letter of each word.
// Example: "in_review" -> "In Review".
export function titleCaseFromSnakeCase(value: string): string {
  return value
    .replace(/_/g, ' ')
    .replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase()
    )
}

// Format an enum
// Usage: formatEnum(EnumObject, value) - Formats the value using the registered formatter for the enum object
// Usage: formatEnum(EnumObject.Value) - Formats the enum using default rules
export function formatEnum<T extends object, V extends keyof T>(
  enumObj: T,
  value?: T[V]
): string {
  if (!value) return '\u2014'

  // We have a registered formatter
  if (typeof enumObj === 'object') {
    const registered = formatters.get(enumObj)
    if (registered) return registered(value)
  }

  return titleCaseFromSnakeCase(value.toString())
}
